/* eslint-disable import/no-commonjs */

/**
 * @remarks
 * We are using the Thesis (design-system-web-react-19) CDN urls now. This correlates to the current CDN version there.
 * @see {@link https://github.com/udemy/design-system-web-react-19/blob/main/packages/icons/src/versions.ts}
 */
module.exports = {
  iconsVersionFolder: 'v15'
};
//# sourceMappingURL=versions.js.map